// eslint-disable-next-line import/no-extraneous-dependencies
import * as history from 'history';

export default history.createBrowserHistory();
